import * as React from 'react';
import { Base } from '@gandi/ui';
import { useFeatureFlag } from '../../hooks/useFeatureFlag';
import Context from './Context';
import { NextSteps } from './components/NextSteps';
import OfflinePayment from './components/OfflinePayment';
import OrderError from './components/OrderError';
import OrderItems from './components/OrderItems';
import OrderStatus from './components/OrderStatus';
import OrderSummary from './components/OrderSummary';
import { OrderSummaryNDS } from './components/OrderSummaryNDS';
import PaymentFailed from './components/PaymentFailed';
import PrepaidRefill from './components/PrepaidRefill';
import SaveCreditCard from './components/SaveCreditCard';
import Thankyou from './components/Thankyou';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function Wrapper(props) {
  return /*#__PURE__*/_jsx("div", {
    id: "payment-return",
    children: props.children
  });
}
const offlineMeanCodes = ['check', 'mandate', 'transfer'];
const paymentFailedStatuses = ['failed', 'cancel'];
function PaymentReturn(props) {
  const paymentFailed = paymentFailedStatuses.indexOf(props.status) > -1;
  const {
    sharingId,
    adminURL
  } = props;
  const contextValue = React.useMemo(() => ({
    sharingId,
    adminURL
  }), [sharingId, adminURL]);
  const FFShopConfirmationNDS = useFeatureFlag('FF_SHOP_CONFIRMATION_NDS');
  if (paymentFailed) {
    return /*#__PURE__*/_jsx(Wrapper, {
      children: /*#__PURE__*/_jsx(PaymentFailed, {
        retryURL: props.retryURL
      })
    });
  }
  if (!props.order) {
    return /*#__PURE__*/_jsx(Wrapper, {
      children: /*#__PURE__*/_jsx(OrderError, {})
    });
  }
  const order = props.order;
  const offlineMean = offlineMeanCodes.indexOf(order.payment_type) > -1;
  const hasItems = Array.isArray(order.items) && order.items.length > 0;
  const refillPrepaid = order.type === 'refill_prepaid';
  if (refillPrepaid) {
    return /*#__PURE__*/_jsxs(Wrapper, {
      children: [/*#__PURE__*/_jsx(Thankyou, {}), /*#__PURE__*/_jsx(PrepaidRefill, {
        adminURL: adminURL,
        sharingId: sharingId,
        order: order,
        offlineMean: offlineMean,
        prepaidBalance: props.prepaidBalance
      })]
    });
  }
  const saveCreditCard = !(offlineMean || order.mycard_id);
  if (FFShopConfirmationNDS) {
    return /*#__PURE__*/_jsx(Wrapper, {
      children: /*#__PURE__*/_jsxs(Context.Provider, {
        value: contextValue,
        children: [/*#__PURE__*/_jsx(Base, {
          marginBottom: "small",
          tagName: "section",
          children: /*#__PURE__*/_jsx(OrderStatus, {
            order: order,
            status: props.status
          })
        }), hasItems && !offlineMean && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(NextSteps, {
            adminURL: props.adminURL,
            sharingId: props.sharingId,
            order: order,
            saveCreditCard: saveCreditCard
          }), /*#__PURE__*/_jsx(OrderSummaryNDS, {
            sharingId: props.sharingId,
            adminURL: props.adminURL,
            order: order
          })]
        }), offlineMean && /*#__PURE__*/_jsx(OfflinePayment, {
          order: order
        })]
      })
    });
  }
  return /*#__PURE__*/_jsx(Wrapper, {
    children: /*#__PURE__*/_jsxs(Context.Provider, {
      value: contextValue,
      children: [/*#__PURE__*/_jsx(Thankyou, {}), /*#__PURE__*/_jsx(Base, {
        marginBottom: "small",
        tagName: "section",
        children: /*#__PURE__*/_jsx(OrderStatus, {
          order: order,
          status: props.status
        })
      }), hasItems && !offlineMean && /*#__PURE__*/_jsx(OrderItems, {
        sharingId: props.sharingId,
        adminURL: props.adminURL,
        order: order
      }), /*#__PURE__*/_jsx(OrderSummary, {
        sharingId: props.sharingId,
        adminURL: props.adminURL,
        order: order
      }), offlineMean && /*#__PURE__*/_jsx(OfflinePayment, {
        order: order
      }), saveCreditCard && /*#__PURE__*/_jsx(SaveCreditCard, {
        adminURL: props.adminURL,
        sharingId: props.sharingId
      })]
    })
  });
}
export default PaymentReturn;